import { Text, Title } from '@vkontakte/vkui';
import { ReactComponent as CloseIcon } from 'img/icons/close__1.svg';
import React, { FC } from 'react';
import { Portal } from 'react-portal';
import { Tooltip}  from 'reactApp/ui/Tooltip/Tooltip';

import styles from './SearchTooltip.css';
import { searchTooltipData, SearchTooltipTypes } from './SearchTooltip.data';

interface Props {
    targetRef: HTMLElement | null;
    type: SearchTooltipTypes;
    onClose: () => void;
}

export const SearchTooltip: FC<Props> = ({ targetRef, type, onClose }) => {
    const data = searchTooltipData[type];
    return (
        <Portal>
            <Tooltip
                theme="octavius"
                target={targetRef}
                placement="bottomRight"
                offset={{
                    y: 10,
                }}
                smartPlacement={false}
                minWidth={false}
            >
                <div className={styles.searchTooltip} onMouseDown={onClose}>
                    <div className={styles.searchTooltipHeader}>
                        <Title level="3">{data.title}</Title>{' '}
                        <CloseIcon width={14} height={14} fill="#A5A7AD" className={styles.searchTooltipClose} />
                    </div>
                    <Text>{data.description}</Text>
                </div>
            </Tooltip>
        </Portal>
    );
};

SearchTooltip.displayName = 'SearchTooltip';
